import React from "react";

import styled from "styled-components/macro";

import {
  FnrToggle,
  FnrToggleChild,
  FnrToggleItems,
  FnrToggleTitle,
} from "UI/FnrToggle2";

export default function GenderToggle({
  gender,
  setGender,
  style,
  disabled,
  title = "Gender",
}) {
  return (
    <FnrToggle style={style} disabled={disabled}>
      <FnrToggleTitle>{title}</FnrToggleTitle>
      <FnrToggleItems style={{ flexWrap: "nowrap" }}>
        <FnrToggleChild key="Male" selected={gender === "Male"}>
          <GenderButton
            onClick={() =>
              setGender((currentGender) =>
                currentGender === "Male" ? null : "Male"
              )
            }
          >
            <GenderIcon className="fas fa-male" />
            Male
          </GenderButton>
        </FnrToggleChild>
        <FnrToggleChild key="Female" selected={gender === "Female"}>
          <GenderButton
            onClick={() =>
              setGender((currentGender) =>
                currentGender === "Female" ? null : "Female"
              )
            }
          >
            <GenderIcon className="fas fa-female" />
            Female
          </GenderButton>
        </FnrToggleChild>
      </FnrToggleItems>
    </FnrToggle>
  );
}

const GenderButton = styled.div`
  padding: 8px 10px;
  font-weight: 400;
  font-size: 16px;
  display: flex;
  align-items: center;
`;
const GenderIcon = styled.div`
  font-size: 20px;
  margin-right: 6px;
`;
